@if (isEditable()) {
  <aura-edit-wrapper
    [title]="
      showMode() === 'demographics'
        ? 'Informations démographiques'
        : showMode() === 'names'
          ? 'Nom et prénom'
          : 'Identité'
    "
    [(isEditing)]="isEditing"
    (saved)="identitySaved.emit($event)"
    [showDivider]="true"
    #editWrapper="auraEditWrapper"
  >
    @if (editWrapper.isEditing()) {
      <aura-person-identity-form
        [dto]="currentIdentity()"
        [showMode]="showMode()"
        [requiredFields]="['firstName', 'lastName', 'gender', 'birthDate']"
        [allReadonly]="!editWrapper.isEditing()"
        (validityChanged)="editWrapper.onValidityChanged($event)"
        (dtoChanged)="editWrapper.onDtoChanged($event)"
      />
    } @else {
      <aura-person-identity-display [currentIdentity]="currentIdentity()" [showMode]="showMode()" />
    }
  </aura-edit-wrapper>
} @else {
  <aura-person-identity-display [currentIdentity]="currentIdentity()" [showMode]="showMode()" />
  <mat-divider class="my-4"></mat-divider>
}
